import { createSlice } from "@reduxjs/toolkit";
const initialState =[]

const SliceGRNLocationGroup = createSlice({
  name: "SliceGRNLocationGroup",
  initialState: { value: initialState },

  reducers: {
    GrnLocationGroup_Set: (state, action) => {
      state.value = action.payload;
    },
    GrnLocationGroup_Init: (state) => {
      state.value = initialState;
    }
  },
});

export const {
  GrnLocationGroup_Set,
  GrnLocationGroup_Init, 
} = SliceGRNLocationGroup.actions;
export default SliceGRNLocationGroup.reducer;
